import React, {useMemo} from "react";

import { LoadingSpinner as Icon } from "@churchofjesuschrist/eden-icons";
import {
  spacing8 as textMargin,
  spacing48,
  spacing64,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useManagedStrings from "../../../utils/use-managed-strings";

const LargeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${spacing64} ${spacing48};
`;
const SmallContainer = styled.div`
  display: flex;
`;
const SmallTextHolder = styled.div`
  position: relative;
  top: -3px;
  margin-left: ${textMargin};
`;

const stringGroups = [{ name: "shared", keys: ["loading"] }];

const LoadingSpinner = ({ large = false, smartHideText = false, justSpinner = false, message, ...others }) => {
  const { managedStrings: useStrings } = useManagedStrings(stringGroups);

  const msg = useStrings.loading;
  const missing = msg === "!shared.loading!";
  let showMessage = smartHideText ? !missing : true;
  if (justSpinner) {
    showMessage = false;
  }

  const text = useMemo(() => message || `${useStrings.loading}${large ? "..." : ""}`, [message,useStrings.loading, large]);

  return large ? (
    <LargeContainer {...others}>
      <div>
        <Icon size={spacing64} />
      </div>
      {showMessage && <div>{text}</div>}
    </LargeContainer>
  ) : (
    <SmallContainer {...others}>
      <Icon /> {showMessage && <SmallTextHolder>{text}</SmallTextHolder>}
    </SmallContainer>
  );
};

export default LoadingSpinner;
